// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
const path = require("path-browserify")
const { loadResource } = require("path/middleware")

const onRouteToTrailer = function (nextState) {
  nextState.match.params.section = "about"
  return loadResource(nextState)
}

const getDefaultLaunchedFrom = ({ location }) =>
  path.join(location.pathname, "../")

export default {
  path: "/library/:resourceSlug/about/trailer/",
  components: {
    primary: require("library/show/components/LibraryResourceContainer")
      .default,
    modal: require("./components/about/ResourceTrailer").default
  },
  onEnter: onRouteToTrailer,
  getDefaultLaunchedFrom
}
